var cGridAnimate = '.c-grid-animate .c-grid-animate__first .c-grid-animate__block';
var cGridAnimateSecond = '.c-grid-animate .c-grid-animate__second .c-grid-animate__block';

export default {
	init() {
		var valueLinkHref;
		$(document).on("click", 'a:not([target="_blank"]):not([target="blank"]):not(.tel):not(.scroll-to):not([data-fancybox]):not(.no-page-load)', function(evt){
			/* *** Test si l'utilisateur pèse sur Ctrl ou Cmd + Click (Commande pour ouvrir dans un onglet externe) *** */
			if(evt.metaKey != true){
				valueLinkHref = $(this).attr("href");

				if(valueLinkHref != undefined){
					if(!$(this).parent().parent().hasClass('no-pjax-dropdown')){
						/* eslint-disable-next-line */
						TweenMax.staggerTo(cGridAnimate, 1, { ease: Expo.easeOut, delay:0.2, height: '100%' }, 0);
						//$('.c-grid-animate').addClass('c-grid-animate--active');

						setTimeout(function(){
							/* eslint-disable-next-line */
							TweenMax.staggerTo(cGridAnimate, 1, { ease: Expo.easeOut, height: '100%' }, 0);
							//$('.c-grid-animate').removeClass('c-grid-animate--active');
						}, 5000);
					}
				}
			}
		});

	},
	finalize() {
		$(window).on('load', function(){
			$('html').addClass('dom-loaded');

			/* eslint-disable-next-line */
			TweenMax.staggerTo(cGridAnimate, 1.4, { ease: Expo.easeOut, height: 0 }, 0.04);

			/* eslint-disable-next-line */
			TweenMax.to(cGridAnimateSecond, 0, { opacity: 1 });
			/* eslint-disable-next-line */
			TweenMax.staggerFrom(cGridAnimateSecond, 2.2, { ease: Expo.easeOut, delay: 1, height: '0%', backgroundColor: '#999999' }, 0.04);

			setTimeout(function () {
				/* eslint-disable-next-line */
				//TweenMax.to($('body'), 2, {opacity:0});

				//onCompleteAnimation();
			}, 800);
			onCompleteAnimation();
		});
	},

};

function onCompleteAnimation() {
	$('html').addClass('dom-animated');

	$("body").initScrollMagic();
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js